import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Seo } from "../components/Seo";

const FAQS = [
    {
        q: "É necessário criar conta?",
        a: "Não. Todas as ferramentas da primeira versão funcionam imediatamente, sem login, e-mail ou cadastro.",
    },
    {
        q: "Os arquivos ficam salvos?",
        a: "Não. Os arquivos de entrada são descartados assim que o processamento termina, e o resultado é apagado de forma definitiva em até 60 minutos.",
    },
    {
        q: "Quais são os limites de uso?",
        a: "No plano gratuito: 10 operações por dia, até 25 MB por arquivo, até 10 arquivos por operação e até 200 páginas por documento. No plano Pro: 200 operações por dia, 100 MB, 50 arquivos e 1.000 páginas. Um fluxo de várias etapas conta como 1 operação.",
    },
    {
        q: "Meu PDF é protegido por senha. Consigo processar?",
        a: "Não. Por segurança, documentos protegidos por senha são recusados. Remova a proteção com a senha original antes de usar as ferramentas.",
    },
    {
        q: "Vocês usam meus documentos para treinar IA?",
        a: "Não. O conteúdo dos arquivos nunca é lido, registrado em log ou usado para treinamento de modelos. Os documentos existem apenas pelo tempo necessário para processar a sua operação.",
    },
    {
        q: "O serviço é realmente gratuito?",
        a: "Sim, as ferramentas atuais são gratuitas. No futuro pode existir um plano Pro com limites maiores, mas as operações básicas continuarão gratuitas.",
    },
    {
        q: "Meu download expirou. E agora?",
        a: "Por privacidade, resultados ficam disponíveis por no máximo 60 minutos. Se o link expirou, basta repetir a operação — ela leva poucos segundos.",
    },
    {
        q: "Funciona no celular?",
        a: "Sim. A plataforma foi desenhada para telas pequenas, com áreas de toque amplas e sem necessidade de instalar aplicativo.",
    },
];

export default function FaqPage() {
    const [open, setOpen] = useState(0);
    return (
        <main className="py-14 px-6 max-w-4xl mx-auto min-h-[60vh]">
            <Seo
                title="Perguntas frequentes — ScorpionPDF"
                description="Dúvidas sobre cadastro, privacidade, limites de uso, exclusão automática de arquivos e funcionamento das ferramentas de PDF."
            />
            <span className="font-mono-tag text-xs font-bold text-[#0284C7] uppercase">Ajuda</span>
            <h1 className="font-poster text-5xl md:text-6xl text-black mt-1">Perguntas frequentes</h1>
            <div className="mt-10 space-y-4">
                {FAQS.map((item, i) => {
                    const isOpen = open === i;
                    return (
                        <div key={item.q} className="border-2 border-black bg-white">
                            <button
                                className="w-full flex items-center justify-between gap-4 p-5 text-left"
                                onClick={() => setOpen(isOpen ? -1 : i)}
                                aria-expanded={isOpen}
                                data-testid={`faq-question-${i}`}
                            >
                                <span className="font-bold text-black text-sm">{item.q}</span>
                                <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" />
                            </button>
                            {isOpen && (
                                <p className="px-5 pb-5 text-sm text-gray-700 leading-relaxed" data-testid={`faq-answer-${i}`}>
                                    {item.a}
                                </p>
                            )}
                        </div>
                    );
                })}
            </div>
        </main>
    );
}
